const PrivacyPolicy = () => {
  return (
    <div className="mx-[5%] lg:mx-[10%] 2xl:mx-[16%]">
      <div className="flex justify-center">
        <div>
          <h1 className="text-[50px] lg:text-[100px] 2xl:text-[147px] font-[400] text-[#FFFFFF]">
            Privacy Policy
          </h1>
        </div>
      </div>
      <div className="w-full py-4">
        {/* privacy policy content */}
        <div>
          <p className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
            At G&G Innovations, we are committed to protecting the privacy and
            security of your personal information. This Privacy Policy outlines
            how we collect, use, disclose, and safeguard the personal
            information we obtain through our website and other channels. By
            using our services and providing us with your personal information,
            you consent to the practices described in this Privacy Policy.
          </p>
        </div>
        {/* information we collect */}
        <div>
          <h1 className="text-[20px] lg:text-[25px] 2xl:text-[30px] text-left text-white">
            1. Information We Collect
          </h1>
          <ul>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              1.1. Personal Information: We may collect personal information,
              such as your name, email address, phone number, and other contact
              details when you voluntarily provide it to us through our website,
              emails, or other means.
            </li>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              1.2. Usage Data: We may collect information about your use of our
              website, including your IP address, browser type, operating
              system, referring URLs, pages visited, and other similar
              information.
            </li>
          </ul>
        </div>
        {/* Use of Information */}
        <div>
          <h1 className="text-[20px] lg:text-[25px] 2xl:text-[30px] text-left text-white">
            2. Use of Information
          </h1>
          <ul>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              2.1. We may use the information we collect for the following
              purposes:
            </li>
            <ul className="pl-8">
              <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300] list-disc ">
                To provide and maintain our services, including customer
                support.
              </li>
              <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300] list-disc ">
                To improve and personalize your experience on our website.
              </li>
              <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300] list-disc ">
                To understand and analyze how users interact with our website.
              </li>
              <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300] list-disc ">
                To protect against fraud, unauthorized transactions, or any
                other illegal activities.
              </li>
              <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300] list-disc ">
                To comply with legal obligations and enforce our policies.
              </li>
            </ul>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              2.2. We may also use the information in aggregated and anonymized
              form for research, statistical analysis, and other legitimate
              business purposes.
            </li>
          </ul>
        </div>
        {/* Information Sharing */}
        <div>
          <h1 className="text-[20px] lg:text-[25px] 2xl:text-[30px] text-left text-white">
            3. Information Sharing
          </h1>
          <ul>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              3.1. We may share your personal information with third parties in
              the following circumstances:
            </li>
            <ul className="pl-8">
              <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300] list-disc ">
                With your consent or at your direction.
              </li>
              <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300] list-disc ">
                With service providers who assist us in operating our business
                and providing services to you.
              </li>
              <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300] list-disc ">
                With law enforcement, government authorities, or other third
                parties if required by applicable laws, regulations, court
                orders, or legal processes.
              </li>
              <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300] list-disc ">
                To protect and defend our rights, property, or safety, and those
                of our users or others.
              </li>
            </ul>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              3.2. We do not sell or rent your personal information to third
              parties for their marketing purposes.
            </li>
          </ul>
        </div>
        {/* Data Security */}
        <div>
          <h1 className="text-[20px] lg:text-[25px] 2xl:text-[30px] text-left text-white">
            4. Data Security
          </h1>
          <ul>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              4.1. We implement appropriate technical and organizational
              measures to protect your personal information from unauthorized
              access, disclosure, alteration, or destruction.
            </li>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              4.2. Despite our efforts, no method of transmission over the
              internet or electronic storage is completely secure. Therefore, we
              cannot guarantee absolute security of your personal information.
            </li>
          </ul>
        </div>
        {/* International Data Transfer */}
        <div>
          <h1 className="text-[20px] lg:text-[25px] 2xl:text-[30px] text-left text-white">
            5. International Data Transfer
          </h1>
          <ul>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              5.1. Your personal information may be transferred to and stored on
              servers located outside your country or the country where you
              provided the information. These countries may have different data
              protection laws than your own.
            </li>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              5.2. By using our services or providing us with your personal
              information, you consent to the transfer of your information to
              countries outside your country of residence.
            </li>
          </ul>
        </div>
        {/* Your Choices and Rights */}
        <div>
          <h1 className="text-[20px] lg:text-[25px] 2xl:text-[30px] text-left text-white">
            6. Your Choices and Rights
          </h1>
          <ul>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              6.1. You have the right to access, update, correct, or delete your
              personal information. You may also object to or restrict certain
              processing of your information. To exercise these rights, please
              contact us using the information provided in Section 8.
            </li>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              6.2. We will make reasonable efforts to fulfill your request,
              subject to any legal or contractual restrictions.
            </li>
          </ul>
        </div>
        {/* Children's Privacy */}
        <div>
          <h1 className="text-[20px] lg:text-[25px] 2xl:text-[30px] text-left text-white">
            7. Children's Privacy
          </h1>
          <ul>
            <li className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
              7.1. Our services are not intended for individuals under the age
              of 16. We do not knowingly collect personal information from
              children without parental consent. If you believe we may have
              collected information from a child without appropriate consent,
              please contact us.
            </li>
          </ul>
        </div>
        {/* Contact Us */}
        <div>
          <h1 className="text-[20px] lg:text-[25px] 2xl:text-[30px] text-left text-white">
            8. Contact Us
          </h1>
          <p className="text-[16px] lg:text-[18px] 2xl:text-[20px] text-[#B2B2B2] py-4 font-[300]">
            If you have any questions, concerns, or requests regarding this
            Privacy Policy or our privacy practices, please contact us at:
            <br /> G&G Innovations <br /> Address: 1113, G&G INNOVATIONS
            INFORMATION TECHNOLOGY L.L.C, Grosvenor Business Tower, Barsha
            Heights - Dubai, UAE <br /> Email: info@gnginfotech.com <br />{" "}
            Phone: +971-04-3349500
          </p>
        </div>
      </div>
    </div>
  );
};
export default PrivacyPolicy;
